/**
* Testimonials JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonials__splide' ).each( function( key, component ) {
        const splider = new Splide( component, {
          type: 'fade',
          rewind: true,
          drag: true,
          arrows: false,
          pagination: true,
          autoplay: true,
          interval: 4000,
        } );
        splider.mount();
        // $( '.testimonial__read-more' ).on( 'click', function() {
        //   splider.Components.Autoplay.pause();
        // } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials', COMPONENT );
} )( app );
